import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'persianNumber'
})
export class PersianNumberPipe implements PipeTransform {

  transform(value): any {
    return new Intl.NumberFormat('fa').format(value);
  }

}
